import theme from '../../base';

const tabNav = {
  traceColor: theme.colors.neutrals.gray300,
  foreground: theme.colors.neutrals.gray700,
  foregroundActive: theme.colors.neutrals.gray800,
  activeColor: theme.colors.blues.blue500,
  focusActiveColor: theme.colors.blues.blue500,
  hoverColor: theme.colors.blues.blue300,
};

export default tabNav;
